export class SessionReasons {

    public static readonly reasons = [
        { "id": 100, "name": "Release Docked" },
        { "id": 101, "name": "Released Locked Inside Docking Station" },
        { "id": 102, "name": "Released Unlocked Inside Docking Station" },
        { "id": 103, "name": "Released Locked Outside" },
        { "id": 104, "name": "Released Unlocked Outside" },
        { "id": 105, "name": "Released Docked Outside" },
        { "id": 200, "name": "Return Docked" },
        { "id": 201, "name": "Undocking  Cancelled" },
        { "id": 202, "name": "Undocking Failed" },
        { "id": 203, "name": "Return Inside Docking Station" },
        { "id": 204, "name": "Return Outside" },
        { "id": 205, "name": "Session Manually Terminated" },
        { "id": 206, "name": "Session Terminated - 12 hours" },
        { "id": 209, "name": "Session Terminated - Not Moving In Docking Area" }
    ];
}


